<!--
 * @Description: 学生请假记录 修改
 * @Author: ZSC
 * @Date: 2023-04-24 15:52:34.578
 * @LastEditors: PF
 * @LastEditTime: 2025-06-06 17:16:19
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openEdit" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">修改</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openEdit', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="请假班级">
              <el-select v-model="banjiid" class="m-2" placeholder="请选择班级" @change="setxvesheng" filterable>
                <el-option v-for="item in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假学生" prop="xsid">
              <el-select v-model="ruleForm.xsid" class="m-2" placeholder="请选择学生" filterable>
                <el-option v-for="item in xveshenglist" :key="item.id" :label="item.xm" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假类型" prop="qjlxid">
              <el-select v-model="ruleForm.qjlxid" class="m-2" placeholder="请选择请假类型" filterable>
                <el-option v-for="item in qingjialeixinglist" :key="item.id" :label="item.bt" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="请假天数" prop="qjts">
              <el-input-number v-model="ruleForm.qjts" placeholder="请假天数" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否离校" prop="sflx">
              <el-radio-group v-model="ruleForm.sflx">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="请假时间" prop="qjkssj">
              <el-date-picker v-model="valuetime" type="datetimerange" start-placeholder="开始时间" @change="shijian" end-placeholder="结束时间" style="width:320px" value-format="YYYY-MM-DD HH:mm" :default-value="[new Date(), new Date()]" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="请假原因" prop="qjyy">
              <el-input v-model="ruleForm.qjyy" :rows="2" type="textarea" placeholder="请假原因" resize="none" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit(0)">存草稿</el-button>
            <el-button type="primary" @click="submit(1)">提交</el-button>
            <el-button type="info" @click="closeWindow('openEdit', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch, unref } from 'vue'
import {
  submitEditForm,
  closeWindow,
  loadData,
  loadSelect
} from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
// import { loadJiGouCascader } from '@/api/queryJiGou.js'

const props = defineProps({
  openEdit: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openEdit', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const valuetime = ref() // 选择了时间
const qingjialeixinglist = ref() // 学生请假类型
const banjiid = ref() // 班级id
const selectxqid = ref() // 学期
const xveshenglist = ref([]) // 学生数据
const setxvesheng = (e) => {
  getbanjixveshenglist()
  ruleForm.value.xsid = ''
}
const banjilist = ref() // 班级数据

// 选择时间
const shijian = (e) => {
  if (e !== null) {
    ruleForm.value.qjkssj = e[0]
    ruleForm.value.qjjssj = e[1]
  } else {
    ruleForm.value.qjkssj = ''
    ruleForm.value.qjjssj = ''
  }
}
const allXq = ref()
// 获取学期
const initSelectList = async () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          selectxqid.value = element.id
          getdengluren()
        }
      })
    }
  })
}
// 查询班级学生
const getbanjixveshenglist = () => {
  loadSelect({
    url: '/api/v2/pdp/xuesheng/banjixuesheng',
    data: xveshenglist,
    order: 'xh',
    parms: { bjid: banjiid.value },
    sort: 'asc'
  })
}
// 查询当前登陆人的班级
const getdengluren = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/banzhuren',
    data: banjilist,
    order: 'xzbdm',
    parms: { xqid: selectxqid.value },
    sort: 'asc',
    loadSuccess: function (res) {
      banjiid.value = res.data[0].id
      getbanjixveshenglist()
    }
  })
}
watch(
  () => props.openEdit,
  () => {
    if (props.openEdit) {
      loadZiDianSelect('学生请假类型', qingjialeixinglist)
      initSelectList()
      loadData({
        url: '/api/v2/jiaowu/xueshengqingjiajilu/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          valuetime.value = [res.data.qjkssj, res.data.qjjssj]
        }
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async (e) => {
  ruleForm.value.zt = e
  ruleForm.value.sqfs = 2
  submitEditForm({
    url: '/api/v2/jiaowu/xueshengqingjiajilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openEdit', emits, true)
    }
  })
}
</script>
